import React from 'react'

import WebinarInfoPanelComponent from '../../../sharedLegacy/components/WebinarInfoPanelComponent/WebinarInfoPanelComponent'
import If from '../../../sharedLegacy/components/If/If'
import { WaitingRoomCountdownComponent } from '../WaitingRoomCountdownComponent/WaitingRoomCountdownComponent'
import { ThankYouMessageComponent } from '../ThankYouMessageComponent/ThankYouMessageComponent'
import { useWebinarColors } from '../../../Designs/blocs/useWebinarColors'
import { useLiveDataQuery } from '../../../global/blocs/useLiveData'
import { useIsWebinarOver } from '../../useAudienceLiveState'

import './SimpleWaitingRoomScreenComponent.scss'
import './SimpleWaitingRoomScreenComponent.mobile.scss'

const renderInfoPanel = () => (
  <WebinarInfoPanelComponent
    theme="waiting-room"
    style={{ color: '#FFFFFF' }}
  />
)

const SimpleWaitingRoomScreenComponent = () => {
  const { data: liveData } = useLiveDataQuery()
  const isWebinarOver = useIsWebinarOver()
  const webinarColors = useWebinarColors()

  return (
    <div className="simple-waiting-room-screen-component">
      <div className="waiting-room-content">
        <If condition={liveData?.before_webinar_countdown_p && !isWebinarOver}>
          <WaitingRoomCountdownComponent />
        </If>
        <If condition={!isWebinarOver || !liveData?.after_webinar_link}>
          <div
            className="decoration-line"
            style={{
              background: `linear-gradient(-90deg, rgb(30, 30, 30) 0%, ${webinarColors.accent.color} 100%)`,
            }}
          />
        </If>
        {isWebinarOver ? <ThankYouMessageComponent /> : renderInfoPanel()}
      </div>
    </div>
  )
}

// oxlint-disable-next-line import/no-default-export
export default SimpleWaitingRoomScreenComponent
